import { useContext, useEffect, useState } from 'react';

import { logEvent } from 'firebase/analytics'; // ajusta el import real que ya usas
import { MarsinetContext } from '../context/marsinetProvider';
import { DeviceNamesMap } from '../helpers/deviceDisplayName';
import { apiServices } from '../services/apiServices';
import { analytics } from '../../firebase';

export const useDeviceNames = () => {
  const { setError } = useContext(MarsinetContext);
  const [deviceNames, setDeviceNames] = useState<DeviceNamesMap>({});
  const [loadingDevices, setLoadingDevices] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;

    const loadDevices = async () => {
      try {
        const response =
          await apiServices.devicesApi.devicesControllerFindAll();

        if (response.data && isMounted) {
          const devicesMap = response.data.reduce((acc, device) => {
            acc[device.d_id] = {
              serial: device.serial,
              model: device.model,
              device_number: device.device_number,
            };
            return acc;
          }, {} as DeviceNamesMap);

          setDeviceNames(devicesMap);
        }
      } catch (error: any) {
        if (error.response?.status !== 401) {
          setError(true);

          logEvent(analytics, 'error_marsinet', {
            error_message: error.message,
            error_code: error.response?.status,
            error_page: window.location.pathname,
            error_stack: error.stack || 'No stack trace',
            timestamp: new Date().toISOString(),
            browser_info: navigator.userAgent,
          });
        }
      } finally {
        if (isMounted) setLoadingDevices(false);
      }
    };

    loadDevices();

    return () => {
      isMounted = false;
    };
  }, []);

  return { deviceNames, loadingDevices };
};
